<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="organizationTypes"
    item-value="id"
    item-text="name"
    clearable
    multiple
    return-object
  >
    <template v-slot:selection="data"> {{ data.item.name }}<br /> </template>
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "OrganizationTypesField",
  props: {
    value: Array,
    status: { type: String, required: false }
  },
  data: () => ({
    organizationTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.post("/api/organizationTypes/search?size=100", { isEffective: this.status }).then(({ data }) => {
      this.organizationTypes = data.content;
    });
  }
};
</script>
